import React, {useContext, useEffect, useRef, useState} from "react";
import * as Yup from "yup";
import {TranslateContext} from "../../context/TranslateContext";
import {AlertMsgContext} from "../../context/AlertMsgContext";
import {
    aggiornaCommentoKpiApi,
    aggiungiCommentoKpiApi,
    getCommentoKpiByIdApi
} from "./services/CommentiServices";
import ModalCommentoKpiView from "./ModalCommentoKpiView";

export default function ModalCommentoKpiController({
                                             idKpi,
                                             idTipoImport,
                                             idCommento,
                                             show,
                                             handleClose,
                                             handleOk
                                         }) {

    const [commento, setCommento] = useState();

    const {translate} = useContext(TranslateContext);
    const {showErrorMessage} = useContext(AlertMsgContext);

    const formikRef = useRef();

    async function getCommento(idCommento) {
        const response = await getCommentoKpiByIdApi(idCommento, idTipoImport);
        if (parseInt(response.data.result) !== -1 && formikRef.current) {
            let data = response.data.data;
            formikRef.current.setFieldValue("testo", data.testo);
            setCommento(data);
        }
    }

    useEffect(() => {
        if (idCommento) {
            getCommento(idCommento);
        }
    }, [idKpi, idTipoImport, idCommento, formikRef]);

    const signupSchema = Yup.object().shape({
        testo: Yup.string()
            .required(translate('Questo campo è obbligatorio'))
    });

    async function aggiornaCommento(values) {
        const response = await aggiornaCommentoKpiApi(idCommento, values)
        if (response.data.result !== 0) {
            showErrorMessage(response.data.description);
        }
        if (response.data.result === 0) {
            handleOk();
        }
    }

    async function aggiungiCommento(values) {
        const response = await aggiungiCommentoKpiApi(idKpi, values)
        if (response.data.result !== 0) {
            showErrorMessage(response.data.description);
        }
        if (response.data.result === 0) {
            handleOk();
        }
    }

    const initialFormValue = {
        id_kpi: idKpi,
        id_tipo_imp_dati: idTipoImport,
        testo: ''
    }

    function onSubmitForm(values) {
        if (idCommento) {
            aggiornaCommento(values);
        } else {
            aggiungiCommento(values);
        }
    }

    function onClickSalva() {
        formikRef.current.handleSubmit();
    }

    return (
        <ModalCommentoKpiView
            idCommento={idCommento}
            idKpi={idKpi}
            show={show}
            handleClose={handleClose}
            commento={commento}
            formikRef={formikRef}
            signupSchema={signupSchema}
            initialFormValue={initialFormValue}
            onSubmitForm={onSubmitForm}
            onClickSalva={onClickSalva}
        />
    );
}